import React, { useEffect, useRef } from 'react';
import '../styles/Talent.css'; 
import talentImg from './../../../../assets/company/careers/game.png'; 

const passionAreas = [
  "Data & Analytics",
  "Design & UX",
  "Engineering & Technology",
  "Internships",
  "Sales & Marketing",
  "Software Development"
];

const TalentSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];
    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.top <= windowHeight * 0.9) {
        setTimeout(() => el.classList.add('animate'), 50);
      } else {
        observer.observe(el);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="combined-section">
      <div className="shared-container"> 
        <div className="talent-container">
          <div className="talent-text" ref={textRef}>
            <h2>Changing the game takes talent - Yours!</h2>
            <p>
              Work where you're encouraged to explore your passions, where your skills are nurtured
              and respected. Introduce with leading-edge technologies on absolutely the coolest
              undertakings you'll be able to envision. What's more, get the tools you have to continue
              learning and developing, so you remain consistently on top of things while making a
              difference in the world.
            </p>
          </div>
          <div className="talent-image" ref={imageRef}>
            <img src={talentImg} alt="Talent Visual" />
          </div>
        </div>

        <div className="passion-panel">
          <h2 className="panel-title">What's your Passion?</h2>
          <div className="passion-grid">
            {passionAreas.map((area, index) => (
              <div className="passion-item" key={index}>
                <span className="passion-dot" />
                <span className="passion-text">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalentSection;
